// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__du8pg","spin":"spinner_spin__H2Kdk"};